let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dehcl")).then(() => parcelRequire('l5F6h'));